import { useEffect } from 'react';
import InputFieldSelect from '../../../../../components/molecules/InputField/InputFieldSelect';
import InputField from '../../../../../components/molecules/InputField';

const NodeGeneral = ({ config, onUpdate }) => {
    useEffect(() => {}, [config]);
    return (
        <div className='p-5'>
            <h5 className='fs-8 cursor-pointer'>Type</h5>
            <InputFieldSelect
                config={{
                    name: 'type',
                    options: [
                        { value: 'web_form', label: 'Web Form' },
                        { value: 'api_request', label: 'API Request' },
                        { value: 'edge_operation', label: 'Edge Operation' },
                        { value: 'expression', label: 'Expression' },
                        { value: 'flow_connector', label: 'Flow Connector' },
                        { value: 'task', label: 'Task' },
                    ],
                }}
                defaultValue={config?.type}
                onChange={(value) => onUpdate('type', value)}
                className='form-select-xs'
            />
            {config?.type === 'task' && (
                <>
                    <h5 className='fs-8 cursor-pointer mt-3'>Task</h5>
                    <InputFieldSelect
                        config={{
                            name: 'name',
                            options: [
                                { value: 'dedupe', label: 'Dedupe' },
                                { value: 'send_email', label: 'Send E-Mail' },
                                { value: 'generate_pdf', label: 'Generate PDF' },
                            ],
                        }}
                        defaultValue={config?.config?.name}
                        onChange={(value) => onUpdate('config.name', value)}
                        className='form-select-xs'
                    />
                </>
            )}
            {config?.type === 'flow_connector' && (
                <>
                    <h5 className='fs-8 cursor-pointer mt-3'>Flow ID</h5>
                    <InputField
                        defaultValue={config?.config?.flow_id}
                        config={{
                            name: 'flow_id',
                            placeholder: 'Flow ID',
                            className: 'form-control-xs mt-3',
                        }}
                    />
                </>
            )}
        </div>
    );
};
export default NodeGeneral;
